const SUMMARY_FIELDS = [
  ['successCount', '成功'],
  ['failureCount', '失败'],
  ['recordCount', '记录'],
  ['sourceLogCount', '来源日志'],
  ['eventCount', '经营事件'],
  ['skippedFieldCount', '空值跳过'],
  ['fieldFailureCount', '字段失败'],
  ['expenseUpdatedCount', '费用归属'],
  ['incomeUpdatedCount', '收入归属'],
  ['salaryUpdatedCount', '工资归属'],
  ['updatedCount', '归属事件'],
];

const formatAgentRunSummary = (summary) => {
  if (!summary || typeof summary !== 'object') {
    return '-';
  }
  const parts = SUMMARY_FIELDS.filter(([key]) => summary[key] !== undefined).map(
    ([key, label]) => `${label} ${summary[key]}`,
  );
  if (summary.fieldFailureReason) {
    parts.push(`字段原因 ${summary.fieldFailureReason}`);
  }
  if (summary.failureReason) {
    parts.push(`原因 ${summary.failureReason}`);
  }
  return parts.length > 0 ? parts.join(' / ') : '-';
};

export { formatAgentRunSummary };
